import React, { useEffect, useState } from 'react';
import { Button, TextField, MenuItem, Grid } from '@mui/material';
import ServiceConfigFormattedMessages from '../../../../messages/admin/ServiceConfigFormattedMessages';
import useRouteRequest from '../../../../requests/RouteRequest';

const EditCarrier = ({
  route,
  carrier,
  allCarriers,
  onCancel,
  onSave,
  errorHandler,
}) => {
  const [editCarrier, setEditCarrier] = useState({
    carrier_route_id: '',
    route_id: '',
    provider_id: '',
    carrier_id: '',
    priority: '',
  });
  const { updateCarrier, createCarrier } = useRouteRequest();

  useEffect(() => {
    carrier &&
      setEditCarrier({
        carrier_route_id: carrier?.carrier_route_id,
        route_id: route.route_id,
        provider_id: carrier?.provider_id,
        carrier_id: carrier?.carrier_id,
        priority: carrier?.priority,
      });
  }, [carrier, route]);

  const handleSave = async (e) => {
    e.preventDefault();

    if (editCarrier.carrier_route_id) {
      await updateCarrier(editCarrier, errorHandler);
    } else {
      await createCarrier(editCarrier, errorHandler);
    }

    onSave();
  };

  const handleInputChange = (e) => {
    switch (e.target.name) {
      case 'provider_id':
        setEditCarrier({
          ...editCarrier,
          provider_id: parseInt(e.target.value),
        });
        break;
      case 'carrier_id':
        setEditCarrier({
          ...editCarrier,
          carrier_id: parseInt(e.target.value),
        });
        break;
      case 'priority':
        setEditCarrier({
          ...editCarrier,
          priority: parseInt(e.target.value),
        });
        break;
    }
  };

  return (
    <form onSubmit={handleSave}>
      <Grid container spacing={2}>
        <Grid size={4}>
          <TextField
            id="provider"
            label={ServiceConfigFormattedMessages.provider}
            type="text"
            fullWidth
            value={editCarrier.provider_id || ''}
            onChange={handleInputChange}
            name="provider_id"
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            select
            label={ServiceConfigFormattedMessages.carrier}
            id="carrier"
            value={editCarrier.carrier_id || ''}
            onChange={handleInputChange}
            size="small"
            name="carrier_id"
            fullWidth
          >
            <MenuItem value="">
              <em>{ServiceConfigFormattedMessages.carrier}</em>
            </MenuItem>
            {allCarriers.map((carrier) => (
              <MenuItem key={carrier.carrier_id} value={carrier.carrier_id}>
                {[
                  carrier.carrier_name,
                  carrier.carrier_code,
                  carrier.iso_code_3,
                ]
                  .filter((a) => !!a)
                  .join(' :: ')}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={4}>
          <TextField
            id="priority"
            label={ServiceConfigFormattedMessages.priority}
            type="text"
            fullWidth
            size="small"
            value={editCarrier.priority || ''}
            onChange={handleInputChange}
            name="priority"
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
        <Grid size={12}>
          <Button variant="outlined" color="secondary" onClick={onCancel}>
            Cancel
          </Button>
        </Grid>
        <Grid size={12}>
          <Button variant="contained" color="secondary" type="submit">
            {editCarrier.carrier_route_id ? 'Update' : 'Add'} Carrier
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default EditCarrier;
